/**
 * Волна A (docs/MIGRATION_ROUTER.md §5). Было: <DevRoute exact path='/dev/slide/:id'>.
 * Без шапки/подвала (staticData, волна E). SlidePage читает id через useParams (@compat/router → TanStack-параметры,
 * ключ 'id' совпадает с $id).
 */
import { createFileRoute } from '@tanstack/react-router';
import SlidePage from '@routes/SlidePage';

export const Route = createFileRoute('/dev/slide/$id')({
  staticData: { layout: { withoutHeader: true, withoutFooter: true } },
  component: () => <SlidePage />
});
